module.exports = __webpack_public_path__ + "img/ja-emptry.16c030db.png";